"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.base64ToUrlSafeBase64 = exports.calculateAmount = exports.estimatedFeeSafetyRate = exports.estimatedFees = void 0;
var js_estimateMaxSpendable_1 = __importDefault(require("./js-estimateMaxSpendable"));
var bignumber_js_1 = __importDefault(require("bignumber.js"));
// NOTE: Hedera declares stable fees in USD
//       If we can get the current USD/HBAR price here..
//       > transfer fee is 0.0001 USD
exports.estimatedFees = new bignumber_js_1["default"]("83300"); // 0.000833 ℏ (as of 2021-09-20)
exports.estimatedFeeSafetyRate = 2;
function calculateAmount(_a) {
    var account = _a.account, transaction = _a.transaction;
    return __awaiter(this, void 0, void 0, function () {
        var amount, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!transaction.useAllAmount) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0, js_estimateMaxSpendable_1["default"])({ account: account })];
                case 1:
                    _b = _c.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _b = transaction.amount;
                    _c.label = 3;
                case 3:
                    amount = _b;
                    return [2 /*return*/, {
                            amount: amount,
                            totalSpent: amount.plus(exports.estimatedFees)
                        }];
            }
        });
    });
}
exports.calculateAmount = calculateAmount;
// NOTE: convert from the non-url-safe version of base64 to the url-safe version (that the explorer uses)
function base64ToUrlSafeBase64(data) {
    // Might be nice to use this alternative if .nvmrc changes to >= Node v14.18.0
    // base64url encoding option isn't supported until then
    // Buffer.from(data, "base64").toString("base64url");
    return data.replace(/\//g, "_").replace(/\+/g, "-");
}
exports.base64ToUrlSafeBase64 = base64ToUrlSafeBase64;
//# sourceMappingURL=utils.js.map